import { lazy } from 'react'

export const InviteStudentList = lazy(() => import('./invite_student/InviteStudentList'))
export const AddInviteStudent = lazy(() => import('./invite_student/AddInviteStudent'))
export const StudentInstituteEnrollmentList = lazy(() => import('./student_institute_enrollments/StudentInstituteEnrollmentList'))
export const AddStudentInstituteEnrollment = lazy(() => import('./student_institute_enrollments/AddStudentInstituteEnrollment'))
export const UpdateStudentInstituteEnrollment = lazy(() => import('./student_institute_enrollments/UpdateStudentInstituteEnrollment'))
